$(document).ready(() => {
  initJobOffers()
})

function toggleJobOffer(offerId) {
  const offer = document.querySelector(`*[data-id=${offerId}]`)

  if (!offer) {
    return
  }

  const openOffer = document.querySelector(
    `.job-offer--open:not([data-id=${offerId}])`,
  )

  if (openOffer) {
    openOffer.classList.remove("job-offer--open")
  }

  const currentUrl = window.location.href.split("?")[0]
  const button = offer.querySelector(".job-offer__header .job-offer__toggle")
  offer.classList.toggle("job-offer--open")
  button.classList.toggle("job-offer__toggle--close")
  const contact = offer.querySelector(".job-offer__contact")

  const resetContactStyle = () => {
    contact.style.position = null
    contact.style.top = null
    contact.style.bottom = null
    contact.style.right = null
    contact.style.left = null
    contact.style.transform = null
  }

  const onScroll = () => {
    const y = window.scrollY

    if (
      y >=
      offer.offsetTop + offer.offsetHeight - 355 - contact.offsetHeight
    ) {
      resetContactStyle()

      contact.style.top = "auto"
      contact.style.bottom = 0

      return
    }

    if (y >= offer.offsetTop) {
      resetContactStyle()

      contact.style.position = "fixed"
      contact.style.top = "355px"
      contact.style.right = "auto"
      contact.style.left = `${offer.offsetLeft + offer.offsetWidth + 43}px`
      contact.style.transform = "none"

      return
    }

    resetContactStyle()
  }

  if (offer.classList.contains("job-offer--open")) {
    button.innerHTML = button.dataset.textOpen
    history.replaceState(null, null, `?offer=${offer.dataset.id}`)
    document.addEventListener("scroll", onScroll)
    window.addEventListener("resize", onScroll)
  } else {
    button.innerHTML = button.dataset.textClosed
    history.replaceState(null, null, currentUrl)
    document.removeEventListener("scroll", onScroll)
    window.removeEventListener("resize", onScroll)
  }

  offer.scrollIntoView({ behavior: "smooth" })
}

function initJobOffers() {
  const offers = document.querySelectorAll(".job-offer")

  if (offers.length === 0) {
    return
  }

  if (window.URLSearchParams) {
    const params = new URLSearchParams(window.location.search)
    const offerId = params.get("offer")

    if (offerId) {
      toggleJobOffer(offerId)
    }
  }

  const buttons = document.querySelectorAll(".job-offer__toggle")

  for (const button of buttons) {
    button.addEventListener("click", (e) => {
      e.preventDefault()
      toggleJobOffer(e.target.closest(".job-offer").dataset.id)
    })
  }
}
